/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import util from "util/util.js";

var surveyIconCache = {};
function surveyIcon(selected, approximate, recent, abc) {
	var key = (selected ? 1 : 0) + (approximate ? 2 : 0) + (recent ? 4 : 0) + (abc ? 8 : 0);

	if(!(key in surveyIconCache)) {
		var icon = {
			path: google.maps.SymbolPath.CIRCLE,
			fillColor: recent ? "#008ac9" : approximate ? "#f18e00" : abc ? "#fedd00" : "#e5352c",
			fillOpacity: selected ? 1 : 0.8,
			strokeColor: "#FFFFFF",
			strokeWeight: 2,
			scale: selected ? 7 : 6
		};

		// surveyIconCache[key] = icon;
		surveyIconCache[key] = preRenderedIcon(icon, "circle");
	}

	return surveyIconCache[key];
}

// Pre-renders a Google Maps marker icon to an off-screen canvas, and returns a version of the icon that can
// be rendered *much* faster in Google Maps. It's important to cache this pre-rendered icon, as rendering each
// icon is likely to be slower than not using this method.
function preRenderedIcon(icon, shape) {
	var devicePixelRatio = window.devicePixelRatio || 1;

	var canvas = document.createElement("canvas");
	var size = (icon.scale * 2 + icon.strokeWeight) * devicePixelRatio;
	canvas.width = size;
	canvas.height = size;
	var ctx = canvas.getContext('2d');
	ctx.beginPath();
	if(shape == 'square') {
		ctx.moveTo(1, 1);
		ctx.lineTo(1, size - 1);
		ctx.lineTo(size - 1, size - 1);
		ctx.lineTo(size - 1, 1);
	} else if(shape == 'diamond') {
		ctx.moveTo(0, size / 2);
		ctx.lineTo(size / 2, size);
		ctx.lineTo(size, size / 2);
		ctx.lineTo(size / 2, 0);
	} else {
		// circle
		ctx.arc(size / 2, size / 2, icon.scale * devicePixelRatio, 0, Math.PI * 2);
	}
	ctx.closePath();

	ctx.fillStyle = icon.fillColor;
	ctx.globalAlpha = icon.fillOpacity;
	ctx.fill();

	ctx.lineWidth = icon.strokeWeight * devicePixelRatio;
	ctx.strokeStyle = icon.strokeColor;
	ctx.globalAlpha = 1;
	ctx.stroke();

	return {
		url: canvas.toDataURL(),
		anchor: new google.maps.Point(size / devicePixelRatio / 2, size / devicePixelRatio / 2),
		scaledSize: new google.maps.Size(size / devicePixelRatio, size / devicePixelRatio)
	}
}

function endpointMarker(p, start, map) {
	return new google.maps.Marker({
		map: map,
		position: new google.maps.LatLng(p.lat, p.lon),
		label: start ? "▶" : "◼"
	});
}

function sharedSitePolygonStyle() {
	return {
		strokeColor: "purple",
		strokeWeigth: 2,
		fillOpacity: 0
	}
}

function isSiteBurnt(sharedSite) {
	return sharedSite && sharedSite.metadata && sharedSite.metadata.fire_status === "Burnt";
}


function sharedSiteColor(sharedSite) {
	if(sharedSite && sharedSite.inactive) {
		return "#aaaaaa";
	}
	return isSiteBurnt(sharedSite) ? "red" : "purple";
}

var sharedSiteIcon = util.makeCache(
	function(s) { return isSiteBurnt(s) ? "burnt" : "unburnt" },
	function(s) {
		return {
			path: google.maps.SymbolPath.CIRCLE,
			fillColor: sharedSiteColor(s),
			fillOpacity: 0.8,
			strokeWeight: 0,
			scale: 3
		};
	}
);

function sharedSiteMarkerIcon() {
	if(!sharedSiteMarkerIcon.cached) {
		sharedSiteMarkerIcon.cached = preRenderedIcon({
			fillColor: 'purple',
			fillOpacity: 1,
			strokeColor: "#FFFFFF",
			strokeWeight: 2,
			scale: 6
		}, 'diamond');
	}
	return sharedSiteMarkerIcon.cached;
}

function gridMarkerIcon(color) {
	if(!gridMarkerIcon.cached) {
		gridMarkerIcon.cached = {};
	}
	if(!gridMarkerIcon.cached[color]) {
		gridMarkerIcon.cached[color] = preRenderedIcon({
			fillColor: color,
			fillOpacity: 1,
			strokeColor: '#FFFFFF',
			strokeWeight: 2,
			scale: 6
		}, 'square');
	}
	return gridMarkerIcon.cached[color];
}

export default {
	surveyIcon,
	endpointMarker,
	sharedSitePolygonStyle,
	sharedSiteColor,
	sharedSiteIcon,
	sharedSiteMarkerIcon,
	gridMarkerIcon,
	preRenderedIcon
};
